<template>
    <div class="w-full">
        <CustomTable :data="profiles" :columnsCustom="columnn" :load="table_load">
            <template #other-filter>
                <div class="flex items-center gap-x-[8px] justify-between">
                    <button v-on:click="getData('refresh')" :disabled="table_load" class="size-[35px] border rounded-xl flex items-center justify-center">
                        <RefreshCw color="#2b2b2b" :size="16" strokeWidth="1.3" :class="{'animate-spin':actu_load}"/>
                    </button>

                    <div class="flex items-center gap-x-[8px]">
                        <NewDepartement @child-action="getData"/>
                        <addValidator />
                    </div>
                </div>
            </template>
            <template #row-cell="slotProps">
                <span v-if="slotProps.cellNumber == 1">
                    {{ slotProps.value }}
                </span>
                <span v-else-if="slotProps.cellNumber == 2" class="flex items-center gap-x-[16px] text-black">
                    <button v-on:click="updateProfile(slotProps.value)"
                    class="border rounded-xl h-[35px] px-6 flex items-center gap-x-[12px]"><Check color="#000" :size="16" strokeWidth="1.3"/> Modifier</button>
                    <button v-on:click="removeProfile(slotProps.value.id)"
                    class="text-[#ee4636] border rounded-xl h-[35px] px-6 flex items-center gap-x-[12px]"><X color="#ee4636" :size="16" strokeWidth="1.3"/> Rejeter</button>
                </span>
                <span v-else>{{ slotProps.value }}</span>
            </template>
        </CustomTable>
    </div>
</template>

<script>

import API from '@/service/API'
import Swal from 'sweetalert2'
import CustomTable from "./Custom-table.vue";
// import ShowValidator from '@/components/tables/show-validator.vue'
import {createColumnHelper} from "@tanstack/vue-table";
import {RefreshCw,Check,X} from "lucide-vue-next";
import NewDepartement from '../create/NewDepartement.vue';
import addValidator from '../create/add-validator.vue';
const columnHelper = createColumnHelper();
const columnsRequest = [
  columnHelper.accessor(row => row.id, {
    id: 'id',
    header: 'Id',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row.label, {
    id: 'label',
    header: 'Libelle',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row, {
    id: 'action',
    header: 'Action',
    cell: info => info.getValue(),
  })
];

export default {
    name: 'DepartementTableComponent',
    components: {
        CustomTable,RefreshCw,Check,X,NewDepartement,addValidator
    },
    data() {
        return {
            table_load: false,
            profiles: [],
            users: [],
            columnn: columnsRequest,
            actu_load: false,
        }
    },
    mounted() {
        this.getData();
        // this.getUsers();
    },
    
    methods: {

        getData(type = null) {
            this.table_load = true;
            if(type == 'refresh') this.actu_load = true;
            API.get('getAllProfiles')
                .then((res) => {
                    if (!res.data.status) throw Error(res.data.message);
                    this.profiles = res.data.data
                })
                .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
                .finally(()=>{
                    this.table_load = false;
                    if(type == 'refresh') this.actu_load = false;
                })
        },

        async updateProfile(value) {
            const inputValue = value.label;
            const {value: label} = await Swal.fire({
                title: "Modifier le label",
                input: "text",
                inputLabel: "Le label",
                inputValue,
                showCancelButton: true,
                inputValidator: (value) => {
                    if (!value) {
                    return "Vous devez écrire quelque chose";
                    }
                }
            })
            if(label == inputValue) return;
            API.post('updateProfile/' + value.id, { label: label })
                .then((res) => {
                    if (!res.data.status) throw Error(res.data.message);
                    this.getData();
                    Swal.fire('Succès !','Profil modifié','success');       
                }).catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'));
        },

        removeProfile(id) {
            Swal.fire({
                title: "Confirmer la suppression",
                text: "Cette action est ireversible",
                icon: 'warning',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Je confirme !',
                cancelButtonText: "J'annule",
                showCancelButton: true
            }).then((result) => {
                if (result.isConfirmed) {
                    API.post('removeProfile/' + id)
                        .then((res) => {
                            if (!res.data.status) throw Error(res.data.message);
                            this.getData();
                            Swal.fire('Succès !','Profil supprimé','success');
                        })
                        .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
                }
            })
        },

        getUsers() {
            API.get('getAllEmployees')
                .then((res) => {
                    this.users = res.data.data
                })
                .catch((error) => {
                    console.error(error)
                })
        },
    }
}

</script>